import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';
import type { AccessibleFleet, User } from '@cobliteam/common-types';
import type { UsersAction } from './actions';
import { UsersActionTypes } from './actionTypes';

export interface UsersState {
  loadUsersWebData: WebData<User[]>;
  deleteUserWebData: WebData<void>;
  saveUserWebData: WebData<void>;
  accessibleFleetsWebData: WebData<AccessibleFleet[]>;
}

export const usersInitialState: UsersState = {
  loadUsersWebData: webDataNotAsked(),
  deleteUserWebData: webDataNotAsked(),
  saveUserWebData: webDataNotAsked(),
  accessibleFleetsWebData: webDataNotAsked(),
};

export const usersReducer = (state: UsersState = usersInitialState, action: UsersAction): UsersState => {
  switch (action.type) {
    case UsersActionTypes.LOAD_USERS_REQUEST:
      return {
        ...state,
        loadUsersWebData: webDataFetching(),
      };

    case UsersActionTypes.LOAD_USERS_SUCCEEDED:
      return {
        ...state,
        loadUsersWebData: webDataSuccess(action.payload),
      };

    case UsersActionTypes.LOAD_USERS_FAILED:
      return {
        ...state,
        loadUsersWebData: webDataError(),
      };

    case UsersActionTypes.DELETE_USER_REQUEST:
      return {
        ...state,
        deleteUserWebData: webDataFetching(),
      };

    case UsersActionTypes.DELETE_USER_SUCCEEDED:
      return {
        ...state,
        deleteUserWebData: webDataSuccess(undefined),
      };

    case UsersActionTypes.DELETE_USER_FAILED:
      return {
        ...state,
        deleteUserWebData: webDataError(),
      };

    case UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_SUCCEEDED:
      return {
        ...state,
        accessibleFleetsWebData: webDataSuccess(action.payload),
      };

    case UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_REQUEST:
      return {
        ...state,
        accessibleFleetsWebData: webDataFetching(),
      };

    case UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_FAILED:
      return {
        ...state,
        accessibleFleetsWebData: webDataError(),
      };

    default:
      return state;
  }
};
